// ค้นหาเอกสารจากช่อง "เลขที่ใบกำกับภาษี" ของรายงานภาษีขาย
//
// ช่องนี้ค้นข้ามหลายฟิลด์ ไม่ได้ค้นเฉพาะ taxInvoiceID มีแค่ taxInvoiceID
// เท่านั้นที่เป็น string เสมอ ส่วน paymentID / internalDocument /
// transactionid / refpayment มาจากเอกสารที่ import หรือ push เข้ามา จึงเป็น
// number ได้พอ ๆ กับ string (และบางใบเป็น Timestamp/object)
//
// เดิมโค้ดเรียก field.replace() ตรง ๆ พอเจอฟิลด์ที่ไม่ใช่ string จะ throw
// ทั้ง callback ของ snapshot listener ทำให้ไม่มีการ commit ผลลัพธ์เลย
// ตารางจึงว่างทุกครั้งที่ค้นหา ไม่ใช่แค่เอกสารใบที่มีปัญหา

const SEARCHABLE_FIELDS = [
  "taxInvoiceID",
  "paymentID",
  "internalDocument",
  "transactionid",
  "refpayment",
]

// ตัดช่องว่างออกแล้วเทียบแบบไม่สนตัวพิมพ์เล็ก/ใหญ่
// คืนค่า null เมื่อฟิลด์นั้นเทียบไม่ได้ (null/undefined/"" /object/array)
function normalizeField(field) {
  if (!field) return null
  if (typeof field !== "string" && typeof field !== "number") return null
  return String(field).replace(/\s/g, "").toLowerCase()
}

export function normalizeSearchTerm(term) {
  return normalizeField(term) || ""
}

export function matchesDocSearch(doc, normalizedTerm) {
  if (!normalizedTerm) return true
  if (!doc) return false
  return SEARCHABLE_FIELDS.some(key => {
    const value = normalizeField(doc[key])
    return value !== null && value.includes(normalizedTerm)
  })
}

export default matchesDocSearch
